(function () {
    'use strict';

    angular
        .module('core.directives')
        .directive('unitImages', UnitImages)

    /** @ngInject */
    function UnitImages($q, $rootScope, $timeout, UnitService, HelperService, NotifyService, sweetAlert, PATHS) {
        function UnitImagesDirectiveController($scope) {
            const vm = this;
            let galleryUploadedImages = [];

            // Watch on show tab
            let removeWatchShow = $scope.$watch('vm.show', (newValue, oldValue) => {
                if (newValue)
                    init();
            })

            $scope.$on('$destroy', () => {
                removeWatchShow();
            })

            // Main image
            vm.flowFileAdded = ($file, $flow, isGallery = false) => {
                let blacklist = ['png', 'gif', 'jpg', 'jpeg'];
                let extension = $file.getExtension();

                let form = '.image';

                if (isGallery) {
                    form = '.gallery';
                }

                if (!blacklist.includes(extension)) {
                    NotifyService.error('Apenas imagens nos formatos: PNG, JPG, JPEG ou GIF são permitidas.');
                    HelperService.setErrorMessageForm(form, 'Formato inválido.', true);
                    return false;
                }

                vm.oldFormImageMain = vm.unitMainImage.Url;

                if (isGallery)
                    angular.extend($flow.opts, vm.flowOptionsGallery);
                else {
                    angular.extend($flow.opts, vm.flowOptionsMain);
                    HelperService.startLoading('.loading-holder');
                }

                HelperService.removeErrorMessageForm(form);
            }

            vm.flowFileFinishedMain = ($file, $message) => {
                let message = angular.fromJson($message);

                vm.unitMainImage.Url = message.FileSaveName;
                vm.unitMainImage.Display = HelperService.imageHandlerPath('unit', vm.unitData.Id, message.FileSaveName);

                let imageData = {
                    UnitId: vm.unitData.Id,
                    Main: true,
                    Url: vm.unitMainImage.Url,
                    Description: ''
                }

                vm.saveImage(imageData);
            }

            // Gallery
            vm.flowFileFinishedGallery = ($file, $message, $flow) => {
                let message = angular.fromJson($message);

                message.uniqueIdentifier = $file.uniqueIdentifier;

                galleryUploadedImages.push(message)

                if (galleryUploadedImages.length == $flow.files.length) {
                    $flow.files = [];

                    let uploadPromisses = [];

                    for (let index = 0; index < galleryUploadedImages.length; index++) {
                        const imageUpload = galleryUploadedImages[index];

                        let imageData = {
                            UnitId: vm.unitData.Id,
                            Main: false,
                            Url: imageUpload.FileSaveName,
                            Description: ''
                        }

                        uploadPromisses.push(vm.saveImage(imageData, imageUpload.uniqueIdentifier, false));
                    }

                    galleryUploadedImages = [];

                    HelperService.startLoading('.loading-holder');

                    $q.all(uploadPromisses)
                        .then(() => {
                            HelperService.successCallback();
                            HelperService.stopLoading('.loading-holder');
                        }, error => {
                            HelperService.errorCallback(error);
                            HelperService.stopLoading('.loading-holder');
                        })
                }
            }

            // On file submitted
            vm.flowFileSubmitted = $flow => {
                $flow.upload();
            }

            // On error in upload
            vm.flowFileError = $flow => {
                $flow.files = [];

                NotifyService.error('Não foi possível salvar a imagem.');
                HelperService.stopLoading('.loading-holder');
            }

            // CRUD
            vm.saveImage = (imageData, fileIdentifier, showLoading = true) => {
                if (showLoading)
                    HelperService.startLoading('.loading-holder');

                return UnitService
                    .postImage(imageData)
                    .then(success => {
                        if (!imageData.Main) {
                            success.fullPath = HelperService.imageHandlerPath('unit', vm.unitData.Id, imageData.Url);

                            vm.unitGallery.push(success);

                            $('#' + fileIdentifier).remove();
                        }

                        if (showLoading) {
                            HelperService.stopLoading('.loading-holder');
                            HelperService.successCallback('image');
                        }
                    }, error => {
                        HelperService.errorCallback(error);
                        HelperService.stopLoading('.loading-holder');
                    })
            }

            vm.updateImage = imageData => {
                HelperService.startLoading('.loading-holder');

                UnitService
                    .putImage(imageData)
                    .then(() => {
                        HelperService.stopLoading('.loading-holder');
                        HelperService.successCallback();
                    }, error => {
                        HelperService.errorCallback(error);
                        HelperService.stopLoading('.loading-holder');
                    })
            }

            vm.deleteImage = (imageData, isMainImage = false) => {
                sweetAlert.swal({
                    title: 'Você tem certeza?',
                    text: 'Não é possível desfazer essa ação!',
                    type: 'warning',
                    confirmButtonText: 'Sim, tenho certeza',
                    showCancelButton: true,
                    cancelButtonText: 'Não, cancelar',
                    allowOutsideClick: false,
                    allowEscapeKey: false
                }).then(response => {
                    if (response.value) {
                        HelperService.startLoading('.loading-holder');

                        if (isMainImage)
                            imageData = vm.unitData.UnitImage.find(image => image.Main)

                        UnitService
                            .deleteImage(imageData.Id)
                            .then(() => {
                                if (!imageData.Main) {
                                    var index = vm.unitGallery.indexOf(imageData);

                                    if (index !== -1)
                                        vm.unitGallery.splice(index, 1);
                                } else {
                                    vm.unitMainImage = {
                                        Url: '',
                                        Display: ''
                                    }

                                    if (vm.flowScopeMain.flow.files.length)
                                        vm.flowScopeMain.flow.files[0].cancel();
                                }

                                HelperService.stopLoading('.loading-holder');
                                HelperService.successCallback();
                            }, error => {
                                HelperService.errorCallback(error);
                                HelperService.stopLoading('.loading-holder');
                            })
                    }
                })
            }

            function getImages() {
                let unitImages = Array.isArray(vm.unitData && vm.unitData.UnitImage)
                    ? vm.unitData.UnitImage
                    : [];

                if (unitImages.length) {
                    let unitMainImage = unitImages.find(image => (image.Main));

                    if (unitMainImage) {
                        vm.unitMainImage = unitMainImage;
                        vm.unitMainImage.Display = HelperService.imageHandlerPath('unit', vm.unitData.Id, unitMainImage.Url);
                    }

                    vm.unitGallery = unitImages
                        .filter(image => (!image.Main))
                        .reduce((acc, cur) => {
                            cur.fullPath = HelperService.imageHandlerPath('unit', vm.unitData.Id, cur.Url);

                            acc.push(cur);

                            return acc;
                        }, []);
                }

                HelperService.stopLoading('.loading-holder');
            }

            function initVars() {
                vm.canUserCreate = $rootScope.canUserCreate;
                vm.canUserEdit = $rootScope.canUserEdit;
                vm.unitData = vm.unitData || {};
                vm.unitData.UnitImage = Array.isArray(vm.unitData.UnitImage) ? vm.unitData.UnitImage : [];

                vm.unitMainImage = {
                    Url: '',
                    Display: ''
                }
                vm.unitGallery = [];

                vm.flowOptionsMain = {
                    query: () => {
                        return {
                            Path: `unit/${vm.unitData.Id}`,
                            OldImage: vm.oldFormImageMain,
                            CreateThumb: false,
                            CreateThumbAdmin: false
                        }
                    }
                }

                vm.flowOptionsGallery = {
                    query: () => {
                        return {
                            Path: `unit/${vm.unitData.Id}`,
                            CreateThumb: false,
                            CreateThumbAdmin: false
                        }
                    }
                }

                angular.extend(vm.flowOptionsMain, HelperService.getFlowOptionsDefaults());
                angular.extend(vm.flowOptionsGallery, HelperService.getFlowOptionsDefaultsGallery());
            }

            function init() {
                HelperService.startLoading('.loading-holder');

                initVars();
                getImages();
            }
        }

        return {
            bindToController: true,
            controller: UnitImagesDirectiveController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/unit-images/unit-images.html`,
            scope: {
                unitData: '=',
                show: '='
            }
        }
    }
}());
